// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__pomkS","unreadBadge":"styles_unreadBadge__3n9Jd","modalContent":"styles_modalContent__33rre","modal":"styles_modal__1KBvS"};